import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { Ripple } from 'vuetify/lib/directives';
import VueI18n from 'vue-i18n';
import zhHant from 'vuetify/src/locale/zh-Hant';

Vue.use(Vuetify, {
  directives: {
    Ripple,
  },
});
Vue.use(VueI18n);

const messages = {
  zhHant: {
    $vuetify: {
      ...zhHant,
      dataFooter: {
        ...zhHant.dataFooter,
        pageText: '{2} 筆中的 {0} - {1} 筆',
      },
    },
  },
};

const i18n = new VueI18n({
  locale: 'zhHant', // set locale
  messages, // set locale messages
});
export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params).toString(),
  },
});
